import 'popper.js';
import 'bootstrap';

(function ($) {

  'use strict';

})(jQuery, Drupal);
